import { request } from '_api/v1/base/behemoth/client'

export const getPipes = async (params) => {
    return await request('GET', 'location/pipe/', params)
}
